export const EmtpyResponseError = {
  type: '',
  show: false,
  message: '',
};
